// @ts-nocheck
// TODO: tighten types after migration
import React, { useState, useEffect } from 'react';
import moment from 'moment-timezone';
import './DailyMotivationalQuotes.css';

const FALLBACK_QUOTES = [
    { content: "The only way to do great work is to love what you do.", author: "Steve Jobs", tags: ["motivational"] },
    { content: "Believe you can and you're halfway there.", author: "Theodore Roosevelt", tags: ["motivational"] },
    { content: "Your time is limited, don't waste it living someone else's life.", author: "Steve Jobs", tags: ["motivational"] },
    { content: "The future belongs to those who believe in the beauty of their dreams.", author: "Eleanor Roosevelt", tags: ["motivational"] },
    { content: "Don't watch the clock; do what it does. Keep going.", author: "Sam Levenson", tags: ["motivational"] },
    { content: "Success is not final, failure is not fatal: It is the courage to continue that counts.", author: "Winston Churchill", tags: ["motivational"] },
    { content: "The only limit to our realization of tomorrow will be our doubts of today.", author: "Franklin D. Roosevelt", tags: ["motivational"] },
    { content: "It always seems impossible until it's done.", author: "Nelson Mandela", tags: ["motivational"] },
    { content: "Start where you are. Use what you have. Do what you can.", author: "Arthur Ashe", tags: ["motivational"] },
    { content: "Dream big and dare to fail.", author: "Norman Vaughan", tags: ["motivational"] }
];

const STORAGE_KEY = 'daily_motivational_quote';
const NATIVE_TIMEZONE = 'Asia/Kolkata';

const DailyMotivationalQuotes = () => {
    const [quote, setQuote] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const getTodayDate = () => {
        return moment().tz(NATIVE_TIMEZONE).format('YYYY-MM-DD');
    };

    const fetchQuote = async () => {
        setLoading(true);
        setError(null);
        try {
            // Try fetching from API first
            const controller = new AbortController();
            const timeoutId = setTimeout(() => controller.abort(), 3000); // 3 second timeout
            
            const response = await fetch('https://api.quotable.io/random?tags=motivational', {
                signal: controller.signal
            });
            clearTimeout(timeoutId);
            
            if (!response.ok) {
                throw new Error('Failed to fetch quote');
            }
            const data = await response.json();
            
            // Store the new quote with today's date
            const today = getTodayDate();
            const quoteData = {
                date: today,
                quote: data
            };
            localStorage.setItem(STORAGE_KEY, JSON.stringify(quoteData));
            
            setQuote(data);
        } catch (err) {
            console.warn("API fetch failed, using fallback:", err);
            // Use fallback on any error
            const randomQuote = FALLBACK_QUOTES[Math.floor(Math.random() * FALLBACK_QUOTES.length)];
            
            // Store the fallback quote with today's date
            const today = getTodayDate();
            const quoteData = {
                date: today,
                quote: randomQuote
            };
            localStorage.setItem(STORAGE_KEY, JSON.stringify(quoteData));
            
            setQuote(randomQuote);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const checkAndLoadQuote = () => {
            const today = getTodayDate();
            const storedData = localStorage.getItem(STORAGE_KEY);
            
            if (storedData) {
                try {
                    const parsedData = JSON.parse(storedData);
                    if (parsedData.date === today && parsedData.quote) {
                        // We have a quote for today
                        setQuote(parsedData.quote);
                        setLoading(false);
                        return;
                    }
                } catch (e) {
                    console.error("Error parsing stored quote:", e);
                }
            }
            
            // No valid quote for today, fetch new one
            fetchQuote();
        };

        checkAndLoadQuote();

        // Check every minute if the date has changed (midnight transition)
        const intervalId = setInterval(() => {
            const today = getTodayDate();
            const storedData = localStorage.getItem(STORAGE_KEY);
            if (storedData) {
                try {
                    const parsedData = JSON.parse(storedData);
                    if (parsedData.date !== today) {
                        // Date changed, fetch new quote
                        fetchQuote();
                    }
                } catch (e) {
                    // ignore
                }
            }
        }, 60000); // Check every minute

        return () => clearInterval(intervalId);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    if (loading) {
        return (
            <div className="daily-quote-container relative mx-auto my-[1rem] flex min-h-[220px] w-[min(95%,1000px)] items-center justify-center overflow-hidden rounded-[18px] border border-slider bg-bg p-[20px]" style={{ justifyContent: 'center' }}>
                <div className="loading-quote text-[1rem] font-[600] text-[#666]">Loading inspiration...</div>
            </div>
        );
    }

    if (error && !quote) {
        return (
            <div className="daily-quote-container relative mx-auto my-[1rem] flex min-h-[220px] w-[min(95%,1000px)] items-center justify-center overflow-hidden rounded-[18px] border border-slider bg-bg p-[20px]" style={{ justifyContent: 'center' }}>
                <div className="error-quote rounded-[10px] border border-[#fecaca] bg-[#fff5f5] px-[14px] py-[10px] text-[#dc2626]">
                    <p>Could not load quote.</p>
                </div>
            </div>
        );
    }

    return (
        <div className="daily-quote-container relative mx-auto my-[1rem] flex min-h-[220px] w-[min(95%,1000px)] items-center justify-center overflow-hidden rounded-[18px] border border-slider bg-bg p-[20px]">
            {/* Background Decorative Marks */}
            <div className="quote-mark-bg quote-mark-top pointer-events-none absolute left-[10px] top-[-14px] text-[6rem] opacity-10">“</div>
            <div className="quote-mark-bg quote-mark-bottom pointer-events-none absolute bottom-[-42px] right-[10px] text-[6rem] opacity-10">“</div>

            <div className="daily-quote-content relative z-[1] w-full text-center">
                {quote && (
                    <>
                        <h2 className="daily-quote-text text-[clamp(1.1rem,2.6vw,1.8rem)] font-[800] leading-[1.4] text-post-heading">
                            {quote.content}
                        </h2>
                        
                        <div className="daily-quote-author-container mt-[14px]">
                            <p className="daily-quote-author text-[0.95rem] font-[700] text-[#666]">- {quote.author}</p>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default DailyMotivationalQuotes;
